module.exports = __webpack_public_path__ + "img/0Q3A3001_L_Black.da7246b6.jpg";